import { render, staticRenderFns } from "./MigrationDataModal.vue?vue&type=template&id=8ade6b5e&scoped=true"
import script from "./MigrationDataModal.vue?vue&type=script&lang=js"
export * from "./MigrationDataModal.vue?vue&type=script&lang=js"
import style0 from "./MigrationDataModal.vue?vue&type=style&index=0&id=8ade6b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade6b5e",
  null
  
)

export default component.exports